export default {
  state: {
    idsFilterEstablishments: []
  },

  mutations: {
    CLEAR_IDS_FILTER_ESTABLISHMENT (state) {
      state.idsFilterEstablishments = []
    },
    SET_IDS_FILTER_ESTABLISHMENT (state, establishmentsIds) {
      state.idsFilterEstablishments = establishmentsIds
    },
    PUSH_ID_FILTER_ESTABLISHMENT (state, establishmentsId) {
      state.idsFilterEstablishments.push(establishmentsId)
    }
  },

  actions: {
    setEstablishmentFilter: ({ commit }, establishmentsIds) => {
      return new Promise((resolve, reject) => {
        commit('SET_IDS_FILTER_ESTABLISHMENT', establishmentsIds)
        resolve()
      })
    },

    addEstablishmentFilter: ({ commit }, establishmentsId) => {
      return new Promise((resolve, reject) => {
        commit('PUSH_ID_FILTER_ESTABLISHMENT', establishmentsId)
        resolve()
      })
    },

    clearEstablishmentFilter: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAR_IDS_FILTER_ESTABLISHMENT')
        resolve()
      })
    }
  },

  getters: {
    idsFilterEstablishments: state => state.idsFilterEstablishments
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/filter.js